import axios from "axios";
import React, { useEffect, useState } from "react";
import { hostname } from "src/HostName";

const useGetSupplierApi = () => {
  const [stateObjData, setStateObjData] = useState({
    loading: true,
    getSupplierList: [],
    error: "",
  });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${hostname}get/supplier`);
        setStateObjData((pre) => ({
          ...pre,
          getSupplierList: data.data || [],
        }));
      } catch (error) {
        setStateObjData((pre) => ({
          ...pre,
          error: "error",
        }));
      }
      setStateObjData((pre) => ({
        ...pre,
        loading: false,
      }));
    })();
  }, []);
  return stateObjData;
};

export default useGetSupplierApi;
